import axios, { AxiosResponse } from 'axios';
import { ApiResponse } from 'registerations/hooks/types';

const API_BASE_URL = 'http://backend.35.182.22.86.nip.io/';

const apiService = axios.create({
  baseURL: API_BASE_URL,
});

interface LoginResponse {
  token: string;
}

interface RegisterResponse {
  message: string;
}


export const login = async (username: string, password: string): Promise<string> => {
  try {
    const response: AxiosResponse<LoginResponse> = await apiService.post('login', { username, password });
    return response.data.token;
  } catch (error) {
    throw error;
  }
};

export const register = async (username: string, password: string): Promise<string> => {
  try {
    const response: AxiosResponse<RegisterResponse> = await apiService.post('register', { username, password });
    return response.data.message;
  } catch (error) {
    throw error;
  }
};

export const getData = async (token: string): Promise<ApiResponse> => {
   try {
     const response: AxiosResponse<ApiResponse> = await apiService.get('get_data', {
       headers: {
         Authorization: `Bearer ${token}`,
       },
     });
     return response.data;
   } catch (error) {
     throw error;
   }
 };

export default apiService;
